import { Component, Inject, OnInit } from "@angular/core";
import {
  FormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MasterService } from "../../pages/master/master.service";
import { PurchaseOrderService } from "../../pages/purchase-order/purchase-order-service";
import { dupeOtherCharge } from "src/app/theme/utils/app-validators";

@Component({
  selector: "app-other-charges-dialog",
  templateUrl: "./other-charges-dialog.component.html",
  styleUrls: ["./other-charges-dialog.component.scss"],
})
export class OtherChargesDialogComponent implements OnInit {
  public otherChargesForm: UntypedFormGroup;
  public otherChargesColumns = [
    "Other Charges Type *",
    "Amount *",
    "GST (%)*",
    "Net Amount",
    "Action",
  ];
  otherChargesTypes: any = [];
  gstList: any[] = [];
  editType: any;
  viewType: string;

  constructor(
    public dialogRef: MatDialogRef<OtherChargesDialogComponent>,
    public fb: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data,
    private masterService: MasterService,
    private poService: PurchaseOrderService
  ) {
    dialogRef.disableClose = true;
    this.getAllGstMaster();
    this.buildForm();
  }
  buildForm() {
    this.otherChargesForm = this.fb.group({
      otherChargesDetails: this.fb.array([]),
    });

    this.editType = this.data?.editType;
    this.viewType = this.data?.viewType;

    const initialData = Array.isArray(this.data?.data) ? this.data.data : [];

    if (!initialData.length) {
      if (this.viewType !== "VIEW") {
        this.onNewItemAdded();
      }
    } else {
      initialData.map(this.onNewItemAdded1);
      for (let i = 0; i < initialData.length; i++) {
        this.onQuantityChange({}, i);
      }
    }

    if (this.viewType === "VIEW") {
      this.otherChargesForm.disable();
    }
  }
  get otherChargesDetails() {
    return (this.otherChargesForm.get("otherChargesDetails") as FormArray)
      .controls;
  }
  onNewItemAdded = () => {
    const FormArray = this.otherChargesForm.get("otherChargesDetails") as FormArray;
    (this.otherChargesForm.get("otherChargesDetails") as FormArray).push(
      this.fb.group({
        otherChargesType: [null, Validators.compose([Validators.required, dupeOtherCharge(FormArray)])],
        amount: [0, Validators.required],
        gstPercent: [0, Validators.required],
        netAmount: [0],
      })
    );
  }

  onNewItemAdded1 = (data?) => {
    const FormArray = this.otherChargesForm.get("otherChargesDetails") as FormArray;
    (this.otherChargesForm.get("otherChargesDetails") as FormArray).push(
      this.fb.group({
        otherChargesType: [data?.otherChargesType , [Validators.required,dupeOtherCharge(FormArray)]],
        amount: [data?.amount || 0, Validators.required],
        gstPercent: [data?.gstPercent || 0, Validators.required],
        netAmount: [data?.netAmount || 0],
      })
    );
  }

  onDeleteItem(index: number) {
    (this.otherChargesForm.get("otherChargesDetails") as FormArray).removeAt(
      index
    );
  }
  ngOnInit(): void {
    this.getAllOtherCharges();
  }
  getAllGstMaster() {
    this.masterService.getAllGst().subscribe((res) => {
      this.gstList = res;
    });
  }
  // onQuantityChange(e,index) {
  //   const amount = this.otherChargesDetails[index].get("amount")?.value;
  //   const gstPercent = this.otherChargesDetails[index].get("gstPercent").value;
  //   this.otherChargesDetails[index]
  //     .get("netAmount")
  //     ?.setValue(amount + gstPercent);
  //   this.otherChargesDetails[index].get("netAmount").disable();
  // }

  onQuantityChange(e, index) {
  const amount = +this.otherChargesDetails[index].get("amount")?.value || 0;
  const gstPercent = +this.otherChargesDetails[index].get("gstPercent")?.value || 0;
  const gstAmount = (amount * gstPercent) / 100;
  const netAmount = amount + gstAmount;

  this.otherChargesDetails[index].get("netAmount")?.setValue(netAmount);
  this.otherChargesDetails[index].get("netAmount")?.disable();
}

  close(): void {
    this.dialogRef.close();
  }
  onSave() {
    this.dialogRef.close(this.otherChargesForm.get('otherChargesDetails').getRawValue());
  }
  
  // getAllOtherCharges() {
  //   this.poService.getAllTermsByType("PO").subscribe({
  //     next: (res) => {
  //       this.otherChargesTypes = Array.isArray(res)
  //         ? res
  //         : res?.data || [];
  //     },
  //     error: (error) => {
  //       console.error('Failed to load other charges types', error);
  //       this.otherChargesTypes = [];
  //     },
  //   });
  // }

  getAllOtherCharges() {
    this.poService.getAllTermsByType("OTHER_CHARGES").subscribe({
      next: (res) => {
        this.otherChargesTypes = Array.isArray(res)
          ? res
          : res?.data || [];
      },
      error: (error) => {
        console.error('Failed to load other charges types', error);
        this.otherChargesTypes = [];
      },
    });
  }
}
